import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import './level_selection.css';
import Button from '../components/button';
import lock from '../assets/lock.png';
import yellowStar from '../assets/yellowstar.png';
import purpleStar from '../assets/purplestar.png';
import arrow from '../assets/arrow.png';

const LEVELS_PER_PAGE = 9;

const getLevelPath = (level) => (
  level === 1
    ? '/level_1/gameplay'
    : level === 3
      ? '/level_3/intro'
      : `/level_${level}/wall`
);

const LevelSelection = (props) => {
  const navigate = useNavigate();
  const unlockedPage = Math.floor((props.unlockedLevel - 1) / LEVELS_PER_PAGE);
  const [page, setPage] = useState(unlockedPage);
  const firstLevel = (page * LEVELS_PER_PAGE) + 1;
  const levels = Array.from(
    { length: LEVELS_PER_PAGE },
    (_, index) => firstLevel + index
  );

  const goToLevel = (level) => {
    const levelPath = getLevelPath(level);

    const tl = gsap.timeline({
      onComplete: () => navigate(levelPath)
    });

    tl.fromTo(
      `.level_card_${level}`,
      {
        scale: 1
      },
      {
        scale: 1.18,
        duration: 0.25,
        ease: 'back.out(2)'
      }
    );

    tl.to(
      `.level_card:not(.level_card_${level})`,
      {
        opacity: 0,
        scale: 0.82,
        duration: 0.35,
        ease: 'power2.in'
      },
      '<'
    );

    tl.to(
      '.level_selection_title, .level_actions',
      {
        opacity: 0,
        y: -24,
        duration: 0.35,
        ease: 'power2.in'
      },
      '<'
    );

    tl.to(
      `.level_card_${level}`,
      {
        scale: 2.4,
        opacity: 0,
        duration: 0.45,
        ease: 'power3.in'
      }
    );
  };

  return (
    <div className="level_selection">
      <h1 className="level_selection_title">Level Selection</h1>

      <div className="level_pages">
        {page > 0 && (
          <button
            className="level_page_button level_page_previous"
            type="button"
            onClick={() => setPage((currentPage) => currentPage - 1)}
          >
            <img src={arrow} alt="Previous levels" />
          </button>
        )}

        <div className="level_grid">
          {levels.map((level) => (
            <Button
              key={level}
              className={`level_card level_card_${level} ${
                level < props.unlockedLevel
                  ? 'level_card_completed'
                  : level === props.unlockedLevel
                    ? 'level_card_open'
                    : 'level_card_locked'
              }`}
              onclick={level <= props.unlockedLevel ? () => goToLevel(level) : undefined}
            >
              <span>{level}</span>
              {level > props.unlockedLevel && <img className="level_lock" src={lock} alt="" />}
              {level < props.unlockedLevel && (
                <div className="level_stars">
                  <img src={yellowStar} alt="" />
                  <img src={yellowStar} alt="" />
                  <img src={purpleStar} alt="" />
                </div>
              )}
            </Button>
          ))}
        </div>

        {page < unlockedPage && (
          <button
            className="level_page_button level_page_next"
            type="button"
            onClick={() => setPage((currentPage) => currentPage + 1)}
          >
            <img src={arrow} alt="Next levels" />
          </button>
        )}
      </div>

      <div className="level_actions">
        <Button className="level_home_button" onclick={() => navigate('/home')} />
        <Button className="level_next_button" onclick={() => goToLevel(props.unlockedLevel)} />
      </div>
    </div>
  );
}

export default LevelSelection;
